<template>
  <div class="main">
    <div class="container-shop">
      <!-- 顶部信息栏 -->
      <div class="header-top">
        <div class="headerLeft" @click="handleBack">
          <i class="el-icon-arrow-left">
            <span class="back">{{ $t("shop.back") }}</span></i
          >
        </div>
        <div class="headerRight">
          <span>{{ $t("shop.remaining") }}: {{ point }}</span>
          <el-button type="primary" size="small" @click="openLog()">
            {{ $t("shop.history") }}
          </el-button>
        </div>
      </div>

      <!-- 标签切换栏 -->
      <div class="nav-tabs">
        <button
          class="nav-tab"
          :class="{ active: Number(activeTab) === item.type }"
          @click="switchTab(item.type)"
          v-for="item in tabList"
          :key="item.name"
        >
          {{ item.name }}
        </button>
      </div>
      <!-- 首页内容 -->
      <div v-if="!isLoading && Number(activeTab) === 0" class="shop-main">
        <img class="bg" src="@/assets/shop/bg2.png" alt="" />
        <img class="bg_m" src="@/assets/shop/bg_m2.png" alt="" />
        <div class="bg_date">
          {{ $t("shop.actDate") }}：07/05/2026 - 13/05/2026
        </div>
        <div class="shop-main-list">
          <div class="shop-main-item" v-for="(item, i) in goodsList" :key="i">
            <img class="shop-main-img" :src="item.img" />
            <div class="shop-main-right">
              <div class="shop-main-title">{{ item.name }}</div>
              <div class="shop-main-dec" v-html="item.content"></div>
              <div class="shop-main-price">
                Giá Gốc：<span>{{ item.list_price }}</span>
              </div>
              <div class="shop-main-amount">
                Flash Sale：<span>{{ item.point }} + {{ item.amount }}VND</span>
              </div>
              <div class="shop-main-btn">
                <img
                  @click="handlePush(item.id)"
                  src="../../assets/shop/2/btn.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 内容展示区 -->
      <div class="content-card" v-else>
        <div class="tab-content">
          <!-- 排序选择框 -->
          <div class="goods-sort">
            <el-select
              v-model="recommend_type"
              :placeholder="$t('shop.sort1')"
              @change="handleSortChange"
            >
              <el-option :label="$t('shop.sort2')" value="0"></el-option>
              <el-option :label="$t('shop.sort3')" value="1"></el-option>
              <el-option :label="$t('shop.sort4')" value="2"></el-option>
            </el-select>
          </div>

          <div class="goods-grid">
            <div
              class="goods-item"
              v-for="item in goodsList"
              :key="item.id"
              @click="openGoodsDialog(item)"
            >
              <div class="goods-img">
                <img :src="item.img" alt="" />
              </div>
              <div class="goods-info">
                <div class="goods-title">
                  {{ item.name }}<br />
                  {{ $t("store.RemainingNum") }} :
                  {{ Math.max(0, item.total - item.used) }}/{{ item.total }}
                </div>
                <div class="exchange-price">
                  <strong>
                    {{ item.point }} {{ $t("store.integral") }}
                    <span v-if="Number(item.amount)"
                      >+ {{ item.amount }}VND</span
                    >
                  </strong>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Log ref="logs" />
    <RulesDialog ref="rulesDialog" />
    <RewardDialog ref="rewardDialog" />
    <DrawDialog ref="drawDialog" />
    <GoodsDialog ref="goodsDialog" @exchange-success="handleGoodsExchange" />
    <Footer />
  </div>
</template>

<script>
import Log from "../Info/components/log.vue";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import RulesDialog from "./components/rulesDialog.vue";
import RewardDialog from "./components/rewardDialog.vue";
import DrawDialog from "./components/drawDialog.vue";
import GoodsDialog from "./components/goodsDialog.vue";
import Footer from "@/components/Footer.vue";
import { get } from "lodash";
export default {
  name: "shop",
  components: {
    Log,
    Swiper,
    SwiperSlide,
    RulesDialog,
    RewardDialog,
    DrawDialog,
    GoodsDialog,
    Footer,
  },
  computed: {
    options() {
      const pointValues = [100, 5000];
      return pointValues.map((value) => ({
        value: String(value),
        label: this.$t("shop.point", { point: value }),
      }));
    },
  },
  data() {
    return {
      // 当前激活的标签
      activeTab: "0",
      isLoading: true, // 添加加载状态
      point: 0,
      // 商品列表数据
      goodsList: [],
      tabList: [
        // { name: "Trang chủ", type: "0" },
        // { name: "Hiện Vật", type: "1" },
        // { name: "Coin", type: "2" },
        // { name: "Voucher", type: "4" },
      ],
      atmList: [],
      goodsMainList: [
        { type: 1, id: 44, img: require("../../assets/shop/2/1.png") },
        { type: 1, id: 45, img: require("../../assets/shop/2/2.png") },
        { type: 1, id: 43, img: require("../../assets/shop/2/3.png") },
        { type: 1, id: 47, img: require("../../assets/shop/2/4.png") },
        { type: 1, id: 46, img: require("../../assets/shop/2/5.png") },
      ],
      selectValue: "100",
      // shop_check数据
      shopChecks: [
        { id: 1, img: require("../../assets/shop/reward/1.png"), name: "1" },
        { id: 2, img: require("../../assets/shop/reward/2.png"), name: "2" },
        { id: 3, img: require("../../assets/shop/reward/3.png"), name: "3" },
        { id: 4, img: require("../../assets/shop/reward/4.png"), name: "4" },
        { id: 5, img: require("../../assets/shop/reward/5.png"), name: "5" },
        { id: 6, img: require("../../assets/shop/reward/6.png"), name: "6" },
        {
          id: 7,
          img: require("../../assets/shop/reward/7.png"),
          name: this.$t("shop.coin"),
        },
        {
          id: 8,
          img: require("../../assets/shop/reward/8.png"),
          name: this.$t("shop.fruit"),
        },
        {
          id: 9,
          img: require("../../assets/shop/reward/9.png"),
          name: this.$t("shop.diamond"),
        },
      ],
      // 转盘旋转角度
      wheelRotate: 0,
      wheelTransition: "transform 0.5s ease-out",
      // 是否正在旋转
      isSpinning: false,
      // 选中的结果
      selectedResult: null,
      // 目标ID数组（用于依次转到多个奖品）
      targetIds: [6, 3, 9],
      targetNum: 0,
      // 当前转到的目标索引
      currentSpinIndex: 0,
      // 转盘结果记录
      spinResults: [],
      // 高亮显示的shop_check索引
      highlightedIndex: -1,
      // 当前获奖物品列表
      rewardList: [],
      swiperOptions: {
        direction: "vertical",
        autoplay: {
          delay: 2000,
          disableOnInteraction: false,
        },
        loop: true,
        speed: 800,
        slidesPerView: 3,
        spaceBetween: 10,
      },
      // 显示的记录列表
      recordList: [],
      // 转盘半径（响应式）
      wheelRadius: 10,
      // 商品排序方式
      recommend_type: "0",
    };
  },
  created() {
    this.getSelectData();
  },
  mounted() {
    // 监听窗口resize事件
    window.addEventListener("resize", this.handleResize);
  },
  methods: {
    //获取选择框下拉接口
    getSelectData() {
      let params = {};
      this.$http
        .get("/point/goodsType", { params })
        .then((res) => {
          if (res.data.code === 200) {
            this.tabList = res.data.data;
            this.activeTab = this.tabList[0]?.type || "0";
            this.getInfoList();
          } else {
            this.$message.error(res.data.msg);
          }
          this.isLoading = false; // 请求完成后设置加载完成
        })
        .catch((err) => {
          console.error("获取标签数据失败:", err);
          this.isLoading = false; // 请求失败也设置加载完成
        });
    },
    //获取信息列表
    getInfoList() {
      let params = {
        type: this.activeTab,
      };
      // 如果有排序方式，添加到参数中
      if (this.recommend_type) {
        params.recommend_type = this.recommend_type;
      }
      this.$http.get("/point/goodsList", { params }).then((res) => {
        if (res.data.code === 200) {
          this.goodsList = res.data.data.list;
          this.atmList = res.data.data.atm;
          this.point = res.data.data.point;
          if (this.activeTab == "0") {
            // this.getRewardList(1);
          }
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },

    //获取奖励列表
    getRewardList(type) {
      let params = { type };
      this.$http.get("/point/pointTurntableList", { params }).then((res) => {
        if (res.data.code === 200) {
          if (type === 1) {
            this.recordList = res.data.data;
          } else if (type === 2) {
            this.openRewardDialog(res.data.data); // 直接弹窗显示
          }
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },

    handleBack() {
      this.$router.back();
    },
    /**
     * 切换标签页
     * @param {String} tabName 标签名称
     */
    switchTab(tabName) {
      this.activeTab = tabName;
      this.recommend_type = "0"; // 切换标签时重置排序方式
      this.getInfoList();
    },
    openLog() {
      this.$refs.logs.dialogFormVisible = true;
      this.$refs.logs.logDialog = true;
      this.$refs.logs.getData();
    },
    /**
     * 打开规则弹窗
     */
    openRulesDialog() {
      this.$refs.rulesDialog.open();
    },
    /**
     * 打开奖品弹窗
     */
    openRewardDialog(data) {
      this.$refs.rewardDialog.open(data);
    },
    /**
     * 打开抽奖结果弹窗
     * @param {Object} rewardData 抽奖结果数据
     */
    openDrawDialog(rewardData, point) {
      this.$refs.drawDialog.open(rewardData, point);
    },
    /**
     * 打开商品详情弹窗
     * @param {Object} goodsItem 商品数据
     */
    openGoodsDialog(goodsItem) {
      let item = JSON.parse(JSON.stringify(goodsItem));
      item.code = this.point;
      item.show = true;
      item.btn = this.$t("goodsPay.confirm");
      if (item.pay_type === "2") {
        item.atmList = this.atmList;
      }
      if (Number(item.point) > Number(item.code)) {
        // 积分不足
        item.btn = this.$t("store.NotEnoughPoints");
        item.show = false;
      }
      if (
        Number(item.user_limit) >= Number(item.limit) &&
        Number(item.limit) != -1
      ) {
        // 今日兑换已上限
        item.btn = this.$t("store.exchangeLimit");
        item.show = false;
      }
      if (
        Number(item.daily_limit) >= Number(item.single_limit) &&
        Number(item.single_limit) != -1
      ) {
        // 今日商品不足
        item.btn = this.$t("store.NotEnoughGoods");
        item.show = false;
      }
      if (
        Number(item.user_month_limit) >= Number(item.month_limit) &&
        Number(item.month_limit) != -1
      ) {
        // 本月商品不足

        item.btn = this.$t("store.productExchangeLimit");
        item.show = false;
      }
      if (Number(item.used) >= Number(item.total)) {
        // 该商品已达兑换上限
        item.btn = this.$t("store.productExchangeLimit");
        item.show = false;
      }
      this.$refs.goodsDialog.open(item);
    },
    /**
     * 处理商品兑换
     * @param {Object} goods 商品数据
     */
    handleGoodsExchange(goods) {
      console.log("兑换商品:", goods);
      // 兑换成功后刷新列表数据
      this.getInfoList();
    },
    /**
     * 处理商品排序变化
     */
    handleSortChange(value) {
      console.log("商品排序方式:", value);
      this.recommend_type = value;
      this.getInfoList();
    },

    //处理商品跳转
    handlePush(id) {
      this.switchTab(1);
      window.scrollTo({
        top: 0,
        behavior: "smooth", // 这个就是动画
      });

      setTimeout(() => {
        let index = this.goodsList.findIndex(
          (item) => Number(item.id) == Number(id)
        );
        console.log(index);
        this.openGoodsDialog(this.goodsList[index]);
      }, 1000);
    },
  },

  beforeUnmount() {
    // 组件卸载前移除resize事件监听
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>

<style scoped lang="scss">
@import url(./css/index.scss);

.mySwiper {
  :deep(.swiper-slide) {
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

// shop_rules 样式
.shop_rules {
  cursor: pointer;
  transition: transform 0.2s;

  &:hover {
    transform: scale(1.05);
  }
}
</style>
